import React from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {SectionTitle} from './helpers';
import {getAutoCreatedSignalDefinitions} from '../../../../shared/signalDefinition';
import {getAgentFields} from '../../../../shared/agent';
import {useAgentBuilderServerState} from '../AgentBuilder.state';
import {useCustomer} from '../../../../hooks/api/metadata';
import {RawSignal} from '../../../signals';
import {getFieldLabel} from '../../../../shared/enrichment';

export const SignalsSection = () => {
  const agentId = useAgentBuilderServerState().id;
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];

  const agentFields = getAgentFields({agentId, fieldDefinitions});
  const autoCreatedSignals = agentFields.map((fieldDefinition) => ({
    fieldDefinition,
    signals: getAutoCreatedSignalDefinitions(fieldDefinition),
  }));

  // Hide the section if there are no auto-created signals
  if (!autoCreatedSignals.some(({signals}) => signals.length)) {
    return null;
  }

  return (
    <Flex direction="column" gap="4">
      <SectionTitle>Signals</SectionTitle>
      <Box color="kgray.300">
        On publish, signals will be automatically created for the following
        fields
      </Box>
      {autoCreatedSignals.map(({fieldDefinition, signals}) => {
        if (!signals.length) {
          return null;
        }

        return (
          <Flex key={fieldDefinition.id.toString()} direction="column" gap="2">
            <Box>{getFieldLabel(fieldDefinition)}</Box>
            <Flex columnGap="4" rowGap="2" wrap="wrap">
              {signals.map((signal) => (
                <RawSignal
                  key={`${fieldDefinition.id}-${signal.label}`}
                  category={signal.category}
                  label={signal.label}
                  fontSize="sm"
                />
              ))}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
